import Protobuf from 'pbf';
export function parsePbf(buffer, TileReader) {
  const pbf = new Protobuf(buffer);
  const tile = TileReader.read(pbf);
  return tile;
}
//# sourceMappingURL=tile-loader-utils.js.map